import { PropsWithChildren, Suspense, useEffect } from 'react';
import { connectRemoteConfig, ManagedRemoteConfigProvider } from '@spotify-internal/remote-config-integration-react';
import { BrowserResolver } from '@spotify-internal/remote-config-resolver-browser';
import { Configuration } from '@spotify-internal/remote-config-properties';
import { LoadingIndicator } from '@spotify-internal/encore-web';

import { useUserInfo } from 'context/UserInfo/UserInfoProvider';
import { useTransport } from 'hooks/useTransport/useTransport';

import { properties } from './experimentProperties';

export type ExpetimentationProps = {};

export const withExperimentation: any = connectRemoteConfig({}).withFallbackProps({});

const ExperimentationProvider = ({ children }: PropsWithChildren<{}>) => {
  const { loading, error, data } = useUserInfo();
  let resolveContext: null | { username: string | null } = null;
  const transport = useTransport();

  if (!loading && !error) {
    resolveContext = { username: data?.username || null };
  }

  useEffect(() => {
    if (transport) {
      transport.connect().then(() => {
        transport.authenticate().catch((authenticateError: Error) => {
          if (process.env.NODE_ENV !== 'production') {
            console.log('Error authenticating transport: ', authenticateError.message); //eslint-disable-line
          }
          return;
        });
      });
    }
  }, [transport]);

  // Don't render ManagedRemoteConfigProvider if transport instance isn't ready
  if (!transport) {
    return <>{children}</>;
  }

  return (
    <ManagedRemoteConfigProvider
      resolver={BrowserResolver}
      options={{
        clientId: 'support-site-frontend',
        timeout: 5000,
        transport,
        properties,
        backgroundFetchInterval: 2147483647,
      }}
      initialConfiguration={Configuration.empty()}
      context={resolveContext}
    >
      <Suspense fallback={<LoadingIndicator />}>{children}</Suspense>
    </ManagedRemoteConfigProvider>
  );
};

export default ExperimentationProvider;
